import React from 'react';
const Reports = () => {
  return <div className="py-4" data-id="element-1277">
      <div className="mb-6" data-id="element-1278">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-1279">Reports</h1>
        <p className="text-gray-600" data-id="element-1280">View and download shipment reports</p>
      </div>
      <div className="bg-white rounded-md shadow-sm p-6" data-id="element-1281">
        <p className="text-gray-500" data-id="element-1282">Reporting dashboard coming soon...</p>
      </div>
    </div>;
};
export default Reports;